import React from 'react';
import { motion } from 'framer-motion';
const reformerTomos = [{
  num: 1,
  title: 'Reformer Esencial',
  desc: 'El primer contacto con el Reformer. Footwork, core básico y activación de patrones fundamentales desde la primera sesión.'
}, {
  num: 2,
  title: 'Reformer Intermedio',
  desc: 'Control excéntrico, inestabilidad progresiva y trabajo de cadena anterior profunda. El nivel que más alumnos abandonan sin sistema.'
}, {
  num: 3,
  title: 'Reformer Avanzado',
  desc: 'Control máximo del carro, series invertidas, pliometría y secuencias sin pausa. Para el alumno que está listo para el siguiente nivel.'
}, {
  num: 4,
  title: 'Reformer Casos Especiales',
  desc: 'Adulto mayor, lesiones, restaurativo y terapéutico. El tomo que te protege legalmente y profesionalmente con cada alumno especial.'
}, {
  num: 5,
  title: 'Reformer Fluidez & Coreografía',
  desc: 'Transiciones artísticas, musicalidad y clases que tus alumnos no olvidan. El tomo que te diferencia de cualquier otro instructor.'
}, {
  num: 6,
  title: 'Reformer Experto',
  desc: 'Programación avanzada, periodización y el sistema completo para instructores de nivel experto. Tu obra maestra en Reformer.'
}];
const matTomos = [{
  num: 7,
  title: 'Mat Esencial',
  desc: 'El método original de Joseph Pilates. Posturas base, respiración y confianza desde la primera clase en el suelo.'
}, {
  num: 8,
  title: 'Mat Intermedio (Clásico)',
  desc: 'El orden clásico completo con progresión real. Alineación, correcciones verbales y técnica de los ejercicios fundamentales del Mat.'
}, {
  num: 9,
  title: 'Mat Avanzado',
  desc: 'Teaser, Boomerang y Control Balance. Las series que tus alumnos más avanzados necesitan y vos podés darles con seguridad.'
}, {
  num: 10,
  title: 'Mat Casos Especiales',
  desc: 'Adulto mayor, post-parto, lesiones y restaurativo. Secuencias terapéuticas para los alumnos que más necesitan tu criterio profesional.'
}, {
  num: 11,
  title: 'Mat Fluidez & Coreografía',
  desc: 'Conexión movimiento-respiración en flujo continuo. La clase de Mat que tus alumnos van a querer repetir cada semana.'
}, {
  num: 12,
  title: 'Mat Experto',
  desc: 'Periodización anual, identidad del instructor y el sistema completo para enseñar Mat al más alto nivel profesional.'
}];
export const Product = () => {
  return <section className="py-20 bg-white" data-id="element-201" data-mp="1s557gxzyy5zu">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-202" data-mp="1x1lv7r39aice">
        {/* Product Presentation */}
        <div className="text-center mb-20" data-id="element-203" data-mp="220yq8z4a6vq2">
          <div className="inline-flex items-center justify-center gap-2 px-4 py-2 rounded-full bg-brand-gold/20 text-brand-charcoal font-bold text-sm tracking-wide mb-6" data-id="element-204" data-mp="21zx2pv62wgrg">
            🏆 El Sistema N°1 para Profesores de Pilates Argentinos
          </div>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-brand-charcoal mb-6" data-id="element-205" data-mp="3hh7bixduh4el">
            PILATES 360 — Colección Completa
          </h2>
          <p className="text-2xl text-brand-terracotta font-serif italic mb-8" data-id="element-206" data-mp="15wq1lok0ev6l">
            12 Tomos + 6 Bonus + 2 Élite — Todo resuelto, todos los niveles.
          </p>
          <div className="flex flex-wrap justify-center gap-4 text-lg font-medium text-gray-700" data-id="element-207" data-mp="x0qqlt1fhvo1">
            <span className="bg-brand-sand/30 px-4 py-2 rounded-lg" data-id="element-208" data-mp="s2p8babtu0dm">
              +280 páginas
            </span>
            <span className="bg-brand-sand/30 px-4 py-2 rounded-lg" data-id="element-209" data-mp="n5fb38i74kf8">
              +150 ejercicios detallados
            </span>
            <span className="bg-brand-sand/30 px-4 py-2 rounded-lg" data-id="element-210" data-mp="e3fughb3fict">
              Reformer + Mat
            </span>
            <span className="bg-brand-sand/30 px-4 py-2 rounded-lg" data-id="element-211" data-mp="94w321dqded2">
              Todos los niveles
            </span>
          </div>
        </div>

        {/* Los 12 Tomos */}
        <div className="mb-16" data-id="element-212" data-mp="23idva1p2yzef">
          <div className="text-center mb-12" data-id="element-213" data-mp="23i44ibw7oo7o">
            <h3 className="text-3xl font-serif font-bold text-brand-charcoal mb-4" data-id="element-214" data-mp="23gaucmme3lux">
              Los 12 Tomos Completos
            </h3>
            <p className="text-xl text-gray-600" data-id="element-215" data-mp="1572uw5bmi1ob">
              Sesiones detalladas · Por nivel y objetivo · Listo para usar
              mañana
            </p>
          </div>

          {/* Reformer Series */}
          <div className="mb-16" data-id="element-216" data-mp="w53dvd0lyxld">
            <div className="flex items-center gap-4 mb-8" data-id="element-217" data-mp="w41r4ba8cmnt">
              <div className="h-px bg-brand-sand flex-1" data-id="element-218" data-mp="hgqe04yegull"></div>
              <h4 className="text-xl font-bold tracking-widest text-brand-terracotta uppercase" data-id="element-219" data-mp="hf5nqrj4bxtj">
                SERIE REFORMER
              </h4>
              <div className="h-px bg-brand-sand flex-1" data-id="element-220" data-mp="8hbphb1smu3q"></div>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-221" data-mp="chdu9t2ts3n8">
              {reformerTomos.map((tomo, i) => <motion.div key={i} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} className="bg-brand-cream p-6 rounded-2xl border border-brand-sand hover:shadow-md transition-shadow" data-id="element-222" data-mp="3uoti3t6diu1r" data-mpi={i}>
                  <div className="text-sm font-bold text-brand-terracotta mb-2" data-id="element-223" data-mp="3kyv2kpr1rwm2">
                    TOMO {tomo.num}
                  </div>
                  <h5 className="text-xl font-serif font-bold text-brand-charcoal mb-3" data-id="element-224" data-mp="2rx3z2bquk5y">
                    {tomo.title}
                  </h5>
                  <p className="text-gray-600 leading-relaxed" data-id="element-225" data-mp="ckcmq1uv7crw">{tomo.desc}</p>
                </motion.div>)}
            </div>
          </div>

          {/* Mat Series */}
          <div data-id="element-226" data-mp="lk9g2gs78zta">
            <div className="flex items-center gap-4 mb-8" data-id="element-227" data-mp="ljzm6i41a8ib">
              <div className="h-px bg-brand-sand flex-1" data-id="element-228" data-mp="hj60zwhz77t4"></div>
              <h4 className="text-xl font-bold tracking-widest text-brand-terracotta uppercase" data-id="element-229" data-mp="hkqxhrnup0tm">
                SERIE MAT
              </h4>
              <div className="h-px bg-brand-sand flex-1" data-id="element-230" data-mp="tlgtrf7sprte"></div>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-231" data-mp="tjcn4piiiepf">
              {matTomos.map((tomo, i) => <motion.div key={i} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} className="bg-brand-cream p-6 rounded-2xl border border-brand-sand hover:shadow-md transition-shadow" data-id="element-232" data-mp="13ba3sbsahyvj" data-mpi={i}>
                  <div className="text-sm font-bold text-brand-terracotta mb-2" data-id="element-233" data-mp="3j2eguky3esxo">
                    TOMO {tomo.num}
                  </div>
                  <h5 className="text-xl font-serif font-bold text-brand-charcoal mb-3" data-id="element-234" data-mp="3o2iwy9v39lnd">
                    {tomo.title}
                  </h5>
                  <p className="text-gray-600 leading-relaxed" data-id="element-235" data-mp="2587qnua8f1jy">{tomo.desc}</p>
                </motion.div>)}
            </div>
          </div>
        </div>

        {/* Features Footer */}
        <div className="bg-brand-charcoal text-white rounded-2xl p-8 text-center max-w-4xl mx-auto" data-id="element-236" data-mp="1wboyik9trhof">
          <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-6" data-id="element-237" data-mp="1rd5c6irbk3vj">
            <div className="font-medium" data-id="element-238" data-mp="2o4pfo3xp4nci">
              ✏️ Ejercicios detallados en cada tomo
            </div>
            <div className="font-medium" data-id="element-239" data-mp="2k1jakzmbl27m">⚡ Sistema "Abrí y Dictás"</div>
            <div className="font-medium" data-id="element-240" data-mp="2f39e8louzvkf">📋 Fichas listas para imprimir</div>
            <div className="font-medium" data-id="element-241" data-mp="2a697s9o3kqss">
              🇦🇷 Contenido 100% adaptado a Argentina
            </div>
          </div>
        </div>
      </div>
    </section>;
};